export enum SurveyType {
  IntegratedOpen = 'integrated-open',
  IntegratedTargeted = 'integrated-targeted',
  NonIntegratedOpen = 'non-integrated-open',
  NonIntegratedTargeted = 'non-integrated-targeted',
}
